// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8d-4";
export var collapsed = "_8d-1";
export var headerBar = "_8d-0";
export var leftHeaderContent = "_8d-3";
export var subjectContainer = "_8d-2";